import EnglishMessages from './locales/compiled/en-CA.json'
import FrenchMessages from './locales/compiled/fr-CA.json'
import { FR, EN } from '@avcan/constants/locales'

export default new Map([
    [FR, FrenchMessages],
    [EN.toString, EnglishMessages],
])
